import React from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';
import './style.scoped.scss';
import InfoAPI from '../InfoAPI';
import RegCityLogo from '../../../Account/RegCityLogo';
import TsAndCs from '../../../Account/Text';

const ApiPagesWrapper = ({
  children,
  smallerLogo,
  handleLink,
  signupForm,
  isSmallScreen,
  isRegister,
}) => {
  const showPage = (
    <div className='apiContainer'>
      <div className='apiContainer__leftSide__topHeader'>
        <Link
          to={handleLink}
          className='apiContainer__leftSide__backButton colorBlack'
        >
          <IoMdArrowBack className='mr-2' />
          <b>Back</b>
        </Link>
        <RegCityLogo smallerLogo={smallerLogo} />
      </div>
      <div className='apiContainerSmall__bottom'>
        {children}
        <TsAndCs />
      </div>
    </div>
  );

  return isSmallScreen ? (
    isRegister ? (
      <div className='apiContainerSmall'>
        <div className='apiContainerSmall__containers'>
          <div className='apiContainerSmall__top'>
            <div className='apiContainer__leftSide__topHeader'>
              <Link
                to={handleLink}
                className='apiContainer__leftSide__backButton colorWhite'
              >
                <IoMdArrowBack className='mr-2' />
                <b>Back</b>
              </Link>
              <RegCityLogo smallerLogo={smallerLogo} isPlans />
            </div>
            <InfoAPI />
          </div>
          {children}
        </div>
      </div>
    ) : (
      showPage
    )
  ) : isRegister ? (
    <div className='apiContainer'>
      <div className='apiContainer__containers'>
        <div className='apiContainer__leftSide'>
          <div className='apiContainer__leftSide__topHeader'>
            <Link
              to={handleLink}
              className='apiContainer__leftSide__backButton colorWhite'
            >
              <IoMdArrowBack className='mr-2' />
              <b>Back</b>
            </Link>
          </div>
          <InfoAPI />
        </div>
        <div className='apiContainer__rigthSide'>
          <div className='topHeader'>
            <RegCityLogo smallerLogo={smallerLogo} />
          </div>
          {signupForm}
        </div>
      </div>
    </div>
  ) : (
    showPage
  );
};

export default ApiPagesWrapper;
